(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class CinematicHero extends HTMLElement {
    connectedCallback() {
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.selectBackdropProducts();
      this.selectRevealProduct();
      this.video = this.querySelector('.hero__background-video');
      if (this.video) {
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.loop = true;
        this.video.playsInline = true;
      }
      this.stage = this.querySelector('[data-hero-stage]');
      this.videoLinks = this.querySelector('[data-hero-video-links]');
      this.syncVideoLinks = () => {
        if (!this.videoLinks || !this.stage) return;
        const bounds = this.stage.getBoundingClientRect();
        const mediaRatio = window.matchMedia('(max-width: 749px)').matches ? 9 / 16 : 16 / 9;
        let mediaWidth = bounds.width;
        let mediaHeight = mediaWidth / mediaRatio;
        if (mediaHeight < bounds.height) {
          mediaHeight = bounds.height;
          mediaWidth = mediaHeight * mediaRatio;
        }
        this.videoLinks.style.width = `${mediaWidth}px`;
        this.videoLinks.style.height = `${mediaHeight}px`;
      };
      this.syncVideoLinks();
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.syncVideoLinks);
        this.resizeObserver.observe(this.stage);
      } else {
        window.addEventListener('resize',this.syncVideoLinks);
      }
      this.onVideoEnded = () => {
        this.classList.add('is-product-present');
        try {
          this.video.currentTime = 0;
        } catch {}
        this.ensureAutonomousPlayback();
      };
      this.video?.addEventListener('ended',this.onVideoEnded);
      if (!this.video) {
        this.classList.add('is-sequence-static');
        return;
      }
      this.sequenceInView = true;
      this.playSequence();
      this.onVisibilityChange = () => {
        if (!document.hidden) this.ensureAutonomousPlayback();
      };
      document.addEventListener('visibilitychange',this.onVisibilityChange);
      this.loopGuard = window.setInterval(() => {
        this.ensureAutonomousPlayback();
      },1500);
    }

    secureIndex(length) {
      if (window.crypto?.getRandomValues) {
        const value = new Uint32Array(1);
        window.crypto.getRandomValues(value);
        return value[0] % length;
      }
      return Math.floor(Math.random() * length);
    }

    selectBackdropProducts() {
      const pool = [...this.querySelectorAll('[data-hero-product]')];
      if (pool.length <= 3) return;
      for (let index = pool.length - 1; index > 0; index -= 1) {
        const randomIndex = this.secureIndex(index + 1);
        [pool[index],pool[randomIndex]] = [pool[randomIndex],pool[index]];
      }
      const chosen = pool.slice(0,3);
      const selected = new Set(chosen);
      chosen.forEach((product,index) => { product.dataset.heroSlot = String(index + 1); });
      pool.forEach((product) => { product.hidden = !selected.has(product); });
    }

    selectRevealProduct() {
      const products = [...this.querySelectorAll('[data-hero-reveal-product]')];
      if (!products.length) return;
      let lastProduct = '';
      try {
        lastProduct = window.sessionStorage.getItem('rip-it-hero-reveal') || '';
      } catch {}
      const differentProducts = products.filter((product) => product.dataset.productKey !== lastProduct);
      const choices = differentProducts.length ? differentProducts : products;
      this.revealProduct = choices[this.secureIndex(choices.length)];
      this.revealProduct.hidden = false;
      this.onRevealEnded = (event) => {
        if (event.animationName === 'hero-product-reveal') {
          this.classList.add('is-product-present');
        }
      };
      this.revealProduct.addEventListener('animationend',this.onRevealEnded);
      const image = this.revealProduct.querySelector('[data-hero-reveal-image]');
      if (image && this.revealProduct.dataset.imageSrc) {
        image.sizes = this.revealProduct.dataset.imageSizes || '100vw';
        image.srcset = this.revealProduct.dataset.imageSrcset || '';
        image.src = this.revealProduct.dataset.imageSrc;
      }
      try {
        window.sessionStorage.setItem('rip-it-hero-reveal',this.revealProduct.dataset.productKey || '');
      } catch {}
    }

    ensureAutonomousPlayback() {
      if (!this.video || document.hidden) return;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.loop = true;
      if (this.video.ended) {
        try {
          this.video.currentTime = 0;
        } catch {}
      }
      if (this.video.paused) {
        const playback = this.video.play();
        if (playback) playback.catch(() => {});
      }
    }

    playSequence() {
      if (this.sequenceActive) {
        this.ensureAutonomousPlayback();
        return;
      }
      this.sequenceActive = true;
      this.classList.remove('is-sequence-complete','is-sequence-static');
      this.classList.remove('is-sequence-playing');
      if (this.revealProduct) this.revealProduct.getBoundingClientRect();
      this.classList.add('is-sequence-playing');
      window.clearTimeout(this.productLockTimer);
      this.productLockTimer = window.setTimeout(() => {
        this.classList.add('is-product-present');
      },3600);
      try {
        this.video.currentTime = 0;
      } catch {}
      const playback = this.video.play();
      if (playback) {
        playback.catch(() => {
          this.sequenceActive = false;
          this.classList.remove('is-sequence-playing','is-sequence-static');
          const retry = () => {
            this.sequenceInView = true;
            this.playSequence();
          };
          window.addEventListener('pointerdown',retry,{ once: true, passive: true });
          window.addEventListener('wheel',retry,{ once: true, passive: true });
          window.addEventListener('keydown',retry,{ once: true });
        });
      }
    }

    resetSequence() {
      if (!this.video) return;
      this.sequenceActive = false;
      this.classList.remove('is-sequence-playing','is-sequence-complete','is-sequence-static','is-product-present');
      this.video.pause();
      this.video.currentTime = 0;
    }

    disconnectedCallback() {
      this.video?.removeEventListener('ended',this.onVideoEnded);
      this.revealProduct?.removeEventListener('animationend',this.onRevealEnded);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      window.clearInterval(this.loopGuard);
      window.clearTimeout(this.productLockTimer);
      document.removeEventListener('visibilitychange',this.onVisibilityChange);
      window.removeEventListener('resize',this.syncVideoLinks);
    }
  }

  if (!customElements.get('cinematic-hero')) customElements.define('cinematic-hero',CinematicHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const keys = ['publisher','franchise','format','availability'];
    const params = {publisher:'ripit_publisher',franchise:'ripit_franchise',format:'ripit_format',availability:'ripit_availability'};
    const pageSize = 24;
    const initialize = (root) => {
      if (root.dataset.ripitReady === 'true') return;
      const elements = [...root.querySelectorAll('[data-ripit-item]')];
      const panel = root.querySelector('[data-ripit-filters]');
      const grid = root.querySelector('[data-ripit-grid]');
      if (!elements.length || !panel || !grid) return;
      root.dataset.ripitReady = 'true';
      root.classList.add('ripit-facet-enabled');
      const chips = document.createElement('div');
      chips.className = 'ripit-facet-chips';
      chips.setAttribute('aria-label','Selected filters');
      grid.before(chips);
      const count = root.querySelector('[data-ripit-count]');
      const empty = root.querySelector('[data-ripit-empty]');
      const pagination = root.querySelector('[data-ripit-pages]');
      const items = elements.map(el => ({el,values:{
        publisher:el.dataset.publisher || '',
        franchise:el.dataset.franchise || '',
        format:el.dataset.format || '',
        availability:el.dataset.availability || ''
      }}));
      const urlParams = new URLSearchParams(window.location.search);
      const chosen = Object.fromEntries(keys.map(key => [key,new Set(urlParams.getAll(params[key]))]));
      let page = 1;
      const eligible = (item,ignored) => keys.every(key => key === ignored || chosen[key].size === 0 || chosen[key].has(item.values[key]));
      const writeUrl = (mode = 'push') => {
        const url = new URL(window.location.href);
        panel.querySelectorAll('[data-ripit-hidden]').forEach(el => el.remove());
        keys.forEach(key => {
          url.searchParams.delete(params[key]);
          chosen[key].forEach(value => {
            url.searchParams.append(params[key],value);
            const hidden = document.createElement('input');
            hidden.type='hidden';
            hidden.name=params[key];
            hidden.value=value;
            hidden.dataset.ripitHidden='true';
            panel.appendChild(hidden);
          });
        });
        const next = url.pathname+url.search+url.hash;
        const current = window.location.pathname+window.location.search+window.location.hash;
        if (next !== current) {
          if (mode === 'replace') window.history.replaceState(window.history.state,'',next);
          else window.history.pushState(window.history.state,'',next);
        }
      };
      const jumpToResults = () => {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        grid.scrollIntoView({behavior:reduced ? 'auto' : 'smooth',block:'start'});
      };
      const changePage = nextPage => {
        page=nextPage;
        refresh();
        jumpToResults();
      };
      const showResults = root.querySelector('[data-ripit-show-results]');
      if (showResults) showResults.addEventListener('click',() => {
        panel.classList.remove('is-open');
        const mobileButton=root.querySelector('[data-mobile-filter]');
        if (mobileButton) mobileButton.setAttribute('aria-expanded','false');
        jumpToResults();
      });
      const makeButton = (label,onClick,disabled,current) => {
        const button = document.createElement('button');
        button.type='button';
        button.textContent=label;
        button.className='pagination__item'+(current?' pagination__item--current':'');
        button.disabled=Boolean(disabled);
        if (current) button.setAttribute('aria-current','page');
        button.addEventListener('click',onClick);
        return button;
      };
      const refresh = () => {
        const results = items.filter(item => eligible(item));
        const pages = Math.max(1,Math.ceil(results.length/pageSize));
        page = Math.min(page,pages);
        const shown = new Set(results.slice((page-1)*pageSize,page*pageSize).map(item => item.el));
        elements.forEach(el => { el.hidden = !shown.has(el); });
        if (empty) empty.hidden = results.length > 0;
        if (count) count.textContent=results.length+' products';
        if (showResults) showResults.textContent='View '+results.length+' '+(results.length===1?'product':'products');
        if (pagination) {
          pagination.replaceChildren();
          if (pages > 1) {
            pagination.appendChild(makeButton('Previous',()=>changePage(page-1),page===1,false));
            for (let n=1;n<=pages;n++) pagination.appendChild(makeButton(String(n),()=>changePage(n),false,n===page));
            pagination.appendChild(makeButton('Next',()=>changePage(page+1),page===pages,false));
          }
        }
        chips.replaceChildren();
        keys.forEach(key => chosen[key].forEach(value => {
          const button = document.createElement('button');
          button.type='button';
          button.className='active-facet';
          button.textContent=value+' ×';
          button.setAttribute('aria-label','Remove '+value+' filter');
          button.addEventListener('click',()=>{chosen[key].delete(value);page=1;writeUrl();renderOptions();refresh();});
          chips.appendChild(button);
        }));
      };
      const renderOptions = () => {
        keys.forEach(key => {
          const list = root.querySelector('[data-ripit-options="'+key+'"]');
          if (!list) return;
          const possible = new Map();
          items.filter(item => eligible(item,key)).forEach(item => {
            const value = item.values[key];
            if (value) possible.set(value,(possible.get(value)||0)+1);
          });
          chosen[key].forEach(value => { if (!possible.has(value)) possible.set(value,0); });
          const active = list.contains(document.activeElement) && document.activeElement.matches('input[type="checkbox"]') ? document.activeElement.value : null;
          list.replaceChildren();
          [...possible].sort(([a],[b])=>a.localeCompare(b,undefined,{sensitivity:'base'})).forEach(([value,total]) => {
            if (total === 0 && !chosen[key].has(value)) return;
            const li = document.createElement('li');
            const label = document.createElement('label');
            label.className='facet__label';
            const input = document.createElement('input');
            input.type='checkbox';
            input.value=value;
            input.checked=chosen[key].has(value);
            input.setAttribute('aria-label',value);
            input.addEventListener('change',() => {
              if (input.checked) chosen[key].add(value);
              else chosen[key].delete(value);
              page=1;
              writeUrl();
              renderOptions();
              refresh();
            });
            const text=document.createElement('span');text.textContent=value;
            const number=document.createElement('span');number.className='facet__count';number.textContent=String(total);
            label.append(input,text,number);li.appendChild(label);list.appendChild(li);
          });
          if (active !== null) {
            const focused = [...list.querySelectorAll('input[type="checkbox"]')].find(input => input.value === active);
            if (focused) focused.focus({preventScroll:true});
          }
          const group=root.querySelector('[data-ripit-group="'+key+'"]');
          if (group) group.hidden = list.children.length === 0;
        });
      };
      panel.addEventListener('change',event => {
        if (event.target.closest('[data-ripit-group]')) return;
        if (event.target.matches('input,select')) panel.requestSubmit();
      });
      const nativeKeys = new URLSearchParams(window.location.search);
      keys.forEach(key => nativeKeys.delete(params[key]));
      const baseNativeQuery = nativeKeys.toString();
      const syncFromURL = () => {
        const search = new URLSearchParams(window.location.search);
        keys.forEach(key => search.delete(params[key]));
        if (search.toString() !== baseNativeQuery) {
          window.location.reload();
          return;
        }
        keys.forEach(key => {
          chosen[key].clear();
          new URLSearchParams(window.location.search).getAll(params[key]).forEach(value => chosen[key].add(value));
        });
        page = 1;
        renderOptions();
        refresh();
      };
      window.addEventListener('popstate',syncFromURL);
      renderOptions();
      writeUrl('replace');
      refresh();
    };
    const run = () => document.querySelectorAll('[data-ripit-root]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',run,{once:true});
    else run();
    document.addEventListener('shopify:section:load',run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["three-d-showcase"] && !Shopify.designMode) return;
  try {
    
  class VaultShowcase extends HTMLElement {
    connectedCallback() {
      this.canvas = this.querySelector('[data-vault-canvas]');
      this.stage = this.querySelector('[data-vault-products]');
      const productPool = [...this.querySelectorAll('[data-vault-card]')];
      this.cards = this.randomProducts(productPool,5);
      productPool.forEach((card) => { card.hidden = !this.cards.includes(card); });
      this.cards.forEach((card,index) => { card.dataset.cardIndex = index; });
      this.chapters = [...this.querySelectorAll('[data-vault-chapter]')];
      this.count = this.querySelector('[data-vault-count]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.pointer = { x: 0, y: 0, tx: 0, ty: 0 };
      this.progress = 0;
      this.visible = true;
      this.frame = 0;
      this.start = performance.now();
      this.onScroll = this.onScroll.bind(this);
      this.render = this.render.bind(this);
      this.onPointer = this.onPointer.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.addEventListener('pointermove', this.onPointer, { passive: true });
      this.addEventListener('pointerleave', () => { this.pointer.tx = 0; this.pointer.ty = 0; });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          if (this.visible) this.requestRender();
        }, { rootMargin: '25% 0px' });
        this.observer.observe(this);
      }
      if (!this.reducedMotion.matches && document.body.classList.contains('motion-enabled')) this.setupWebGL();
      this.onScroll();
    }

    randomProducts(products,amount) {
      const shuffled = [...products];
      for (let index = shuffled.length - 1; index > 0; index -= 1) {
        let randomIndex;
        if (window.crypto?.getRandomValues) {
          const value = new Uint32Array(1);
          window.crypto.getRandomValues(value);
          randomIndex = value[0] % (index + 1);
        } else {
          randomIndex = Math.floor(Math.random() * (index + 1));
        }
        [shuffled[index],shuffled[randomIndex]] = [shuffled[randomIndex],shuffled[index]];
      }
      return shuffled.slice(0,Math.min(amount,shuffled.length));
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.removeEventListener('pointermove', this.onPointer);
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    setupWebGL() {
      const gl = this.canvas?.getContext('webgl', { alpha: true, antialias: false, powerPreference: 'high-performance' });
      if (!gl) return;
      const vertex = `attribute vec3 a;uniform float t;uniform float p;uniform vec2 m;uniform float aspect;varying float glow;void main(){vec3 q=a;float spin=p*5.4+t*.035;float c=cos(spin),s=sin(spin);q.xz=mat2(c,-s,s,c)*q.xz;q.x+=m.x*(1.0+q.z*.035);q.y+=m.y*(1.0+q.z*.025);q.z=mod(q.z+p*23.0+10.0,20.0)-10.0;float d=13.0-q.z;vec2 projected=vec2(q.x/aspect,q.y)/d*2.1;gl_Position=vec4(projected,0.0,1.0);gl_PointSize=max(1.0,(9.0/d)*(1.0+a.y*.025));glow=clamp(1.0-d/23.0,.12,1.0);}`;
      const fragment = `precision mediump float;varying float glow;void main(){vec2 uv=gl_PointCoord-.5;float d=length(uv);if(d>.5)discard;float a=smoothstep(.5,0.0,d)*glow;vec3 hot=vec3(1.0,.18,.14);vec3 gold=vec3(1.0,.64,.08);gl_FragColor=vec4(mix(hot,gold,glow*.35),a*.82);}`;
      const compile = (type, source) => {
        const shader = gl.createShader(type);
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        return gl.getShaderParameter(shader, gl.COMPILE_STATUS) ? shader : null;
      };
      const program = gl.createProgram();
      const vertexShader = compile(gl.VERTEX_SHADER, vertex);
      const fragmentShader = compile(gl.FRAGMENT_SHADER, fragment);
      if (!vertexShader || !fragmentShader) return;
      gl.attachShader(program, vertexShader);
      gl.attachShader(program, fragmentShader);
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return;
      const particles = new Float32Array(2400 * 3);
      for (let index = 0; index < particles.length; index += 3) {
        const angle = Math.random() * Math.PI * 2;
        const radius = 1.2 + Math.pow(Math.random(),.55) * 8.5;
        particles[index] = Math.cos(angle) * radius;
        particles[index + 1] = Math.sin(angle) * radius * .58;
        particles[index + 2] = Math.random() * 20 - 10;
      }
      const buffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, particles, gl.STATIC_DRAW);
      this.webgl = {
        gl, program, count: particles.length / 3,
        position: gl.getAttribLocation(program, 'a'),
        time: gl.getUniformLocation(program, 't'),
        progress: gl.getUniformLocation(program, 'p'),
        mouse: gl.getUniformLocation(program, 'm'),
        aspect: gl.getUniformLocation(program, 'aspect')
      };
      gl.enable(gl.BLEND);
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
    }

    onPointer(event) {
      const rect = this.getBoundingClientRect();
      this.pointer.tx = ((event.clientX - rect.left) / rect.width - .5) * 2;
      this.pointer.ty = ((event.clientY - Math.max(0,rect.top)) / window.innerHeight - .5) * -2;
      this.requestRender();
    }

    onScroll() {
      const rect = this.getBoundingClientRect();
      const distance = Math.max(1,rect.height - window.innerHeight);
      this.progress = Math.min(1,Math.max(0,-rect.top / distance));
      this.style.setProperty('--vault-progress',this.progress.toFixed(4));
      const chapter = Math.min(2,Math.floor(this.progress * 3.01));
      this.chapters.forEach((item,index) => item.classList.toggle('is-active',index === chapter));
      if (this.count) this.count.textContent = String(chapter + 1).padStart(2,'0');
      this.cards.forEach((card) => card.tabIndex = this.reducedMotion.matches || this.progress > .68 ? 0 : -1);
      this.requestRender();
    }

    requestRender() {
      if (!this.visible || this.frame) return;
      this.frame = requestAnimationFrame(this.render);
    }

    render(now) {
      this.frame = 0;
      this.pointer.x += (this.pointer.tx - this.pointer.x) * .06;
      this.pointer.y += (this.pointer.ty - this.pointer.y) * .06;
      const mobileScale = this.mobile.matches ? .58 : 1;
      const radius = (300 + Math.sin(this.progress * Math.PI) * 115) * mobileScale;
      this.cards.forEach((card,index) => {
        const angle = (index / Math.max(1,this.cards.length)) * Math.PI * 2 + this.progress * Math.PI * 2.35;
        const focus = Math.max(0,(this.progress - .66) / .34);
        const spreadX = (index - (this.cards.length - 1) / 2) * 185 * mobileScale;
        const orbitX = Math.cos(angle) * radius;
        const orbitY = Math.sin(angle * 1.7) * 82 * mobileScale;
        const orbitZ = Math.sin(angle) * 330 - 80;
        const x = orbitX * (1 - focus) + spreadX * focus;
        const y = orbitY * (1 - focus);
        const z = orbitZ * (1 - focus) + (index === 2 ? 90 : 0) * focus;
        const ry = (-Math.cos(angle) * 32) * (1 - focus);
        const rz = Math.sin(angle) * -7 * (1 - focus);
        const opacity = Math.min(1,Math.max(.12,(z + 410) / 300));
        card.style.setProperty('--card-x',`${x.toFixed(1)}px`);
        card.style.setProperty('--card-y',`${y.toFixed(1)}px`);
        card.style.setProperty('--card-z',`${z.toFixed(1)}px`);
        card.style.setProperty('--card-ry',`${ry.toFixed(1)}deg`);
        card.style.setProperty('--card-rz',`${rz.toFixed(1)}deg`);
        card.style.setProperty('--card-opacity',opacity.toFixed(2));
      });
      if (this.stage) {
        this.stage.style.setProperty('--stage-rx',`${(this.pointer.y * 3.5).toFixed(2)}deg`);
        this.stage.style.setProperty('--stage-ry',`${(this.pointer.x * 5).toFixed(2)}deg`);
      }
      this.style.setProperty('--pointer-x',`${(this.pointer.x * 24).toFixed(1)}px`);
      this.style.setProperty('--pointer-y',`${(this.pointer.y * 18).toFixed(1)}px`);
      this.drawWebGL(now || performance.now());
      const pointerMoving = Math.abs(this.pointer.tx - this.pointer.x) + Math.abs(this.pointer.ty - this.pointer.y) > .01;
      if (this.webgl || pointerMoving) this.requestRender();
    }

    drawWebGL(now) {
      if (!this.webgl) return;
      const { gl,program,count,position,time,progress,mouse,aspect } = this.webgl;
      const ratio = Math.min(window.devicePixelRatio || 1,1.5);
      const width = Math.floor(this.canvas.clientWidth * ratio);
      const height = Math.floor(this.canvas.clientHeight * ratio);
      if (this.canvas.width !== width || this.canvas.height !== height) {
        this.canvas.width = width;
        this.canvas.height = height;
        gl.viewport(0,0,width,height);
      }
      gl.clearColor(0,0,0,0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.useProgram(program);
      gl.enableVertexAttribArray(position);
      gl.vertexAttribPointer(position,3,gl.FLOAT,false,0,0);
      gl.uniform1f(time,(now - this.start) / 1000);
      gl.uniform1f(progress,this.progress);
      gl.uniform2f(mouse,this.pointer.x,this.pointer.y);
      gl.uniform1f(aspect,width / Math.max(1,height));
      gl.drawArrays(gl.POINTS,0,count);
    }
  }

  if (!customElements.get('vault-showcase')) customElements.define('vault-showcase',VaultShowcase);

  } catch(e) { console.error(e); }
})();
})();
